<app-page-header title="Látnivalók"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <div class="h4 content-title text-center py-3">Tájház</div>
  <div class="p-5">
    <p>
      Az épületet 2000 szeptemberében vette meg az önkormányzat Hartmann
      Frigyestől, mivel a ház meglehetősen rossz, már-már életveszélyes
      állapotba került és ő nem tudta önerőből felújítani. Ezért az önkormányzat
      részben felújította, így Frici bácsi, ahogy mindenki ismerte, 2009-ig,
      haláláig benne lakhatott. Önkormányzatunk a 2013-ban benyújtott pályázaton
      (Darányi Ignác Terv) 16 millió Ft támogatást nyert, így készülhetett el a
      falu közepén található tájház. Kivitelezője a Geoszolg Kft. volt.
    </p>
    <p>
      A felújítás során törekedtek a sváb ház eredeti stílusát megtartani. Itt
      állítottuk ki a régi sváb családok háztartási és gazdálkodási eszközeit,
      az otthonukat kiegészítő díszeket, bútorokat, tányérokat és edényeket. Az
      épület célja, hogy megőrizze a német nemzetiségi kultúrát és bemutassa a
      sváb családok életkörnyezetét az érdeklődők számára. A tájház
      berendezéseit a község lakóinak felajánlásaiból gyűjtöttük össze.
    </p>
    <p>A kiállítás előzetes bejelentkezés alapján látogatható.</p>
    <p>Elérhetőségek: +36-30-42-43-914; +36-34/491-819</p>
    <p>Cím: 2897 Dunaszentmiklós, Petőfi S. u. 51.</p>
  </div>
  <div class="h4 content-title text-center py-3">Helyi értéktár</div>
</div>
